/* eslint no-param-reassign: "off" */
import Request from '../../utils/request';

export default {
  name: 'request',
  proto: {
    request: Request,
  },
  static: {
    request: Request,
  },
};
